export default "__VITE_ASSET__Cmd58Rn4__"